import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BAC_ABOUT_DATA } from './bac-about.data';
import { BaseComponent } from '../../base.component';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-about',
  standalone: true,
  imports: [TranslateModule, RouterOutlet, CommonModule],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-about.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacAboutComponent extends BaseComponent {
  public ABOUT_DATA = BAC_ABOUT_DATA;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
